import { EditorFieldType } from '../../enums/editor-field-type-enum.service';
import { UploadFileTypeEnum } from '../../enums/type-file.enum';
import { EditorFieldConfigBase } from './editor-field-config-base.model';

export interface FileFieldConfig extends EditorFieldConfigBase {
  type: EditorFieldType.FILE;
  withLogo: boolean;
  ctaText?: string;
  availableFileTypes?: UploadFileTypeEnum[];
}
